import { render, staticRenderFns } from "./FixedAmountUser.vue?vue&type=template&id=40ba0a14&scoped=true"
import script from "./FixedAmountUser.vue?vue&type=script&lang=js"
export * from "./FixedAmountUser.vue?vue&type=script&lang=js"
import style0 from "./FixedAmountUser.vue?vue&type=style&index=0&id=40ba0a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ba0a14",
  null
  
)

export default component.exports